import { render, staticRenderFns } from "./RouterGo.vue?vue&type=template&id=0c065651&scoped=true"
import script from "./RouterGo.vue?vue&type=script&lang=js"
export * from "./RouterGo.vue?vue&type=script&lang=js"
import style0 from "./RouterGo.vue?vue&type=style&index=0&id=0c065651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c065651",
  null
  
)

export default component.exports